import {
  type UpdateInsuranceMutationVariables,
  useUpdateInsuranceMutation,
} from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useUpdateInsurance = () => {
  const [updateInsuranceMutation] = useUpdateInsuranceMutation({
    context: {
      apiVersion: AppApiVersions.core,
    },
  });

  const updateInsurance = (variables: UpdateInsuranceMutationVariables) =>
    updateInsuranceMutation({
      variables,
    });

  return {
    updateInsurance,
  };
};
